import actionTypes from 'SRC/modules/redux/actionTypes'

export const setServiceProviderPhotos = photos => ({
  type: actionTypes.SET_SERVICE_PROVIDER_PHOTOS,
  payload: photos
})
